import styled from "styled-components";

export const ButtonWrapper = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: row;
    padding: 10px;
`;